import { humanizePriceRange } from '../../helpers/humanization.js';

const getBankrotstvoTerms = item => {
    // Оформление банкротства, Стоимость
    const conditions = [];
    // Оформление банкротства
    const { timeBankrotstvo } = item;
    const timeValue = timeBankrotstvo ? `${timeBankrotstvo} мес` : 'Индивид.';
    conditions.push({ value: timeValue, description: 'Оформление', key: 'time' });
    // Стоимость
    const { minSum } = item;
    const priceValue = humanizePriceRange({
        priceRange: {
            from: minSum,
            to: null,
        },
        allowZero: false,
        defaultValue: 'По запросу',
    });
    conditions.push({
        value: priceValue,
        description: 'Платёж в месяц',
        key: 'price',
    });
    return conditions;
};

export { getBankrotstvoTerms };
//# sourceMappingURL=bankrotstvo.js.map
